import { ServiceResponse } from '@nx-smartmonkey/shared/hooks';
import { useState } from 'react';

import { userService } from '../../application/UserService';
import { useShowSnackbarMessage } from '../snackbarMessage/useShowSnackbarMessage';

interface UseNewUserPassword {
  token: string;
  password: string;
}

type UseNewUserPasswordResponse = ServiceResponse<({ token, password }: UseNewUserPassword) => void, void>;

// Hooks act as 'Adapter' layer.
export const useNewUserPassword = (): UseNewUserPasswordResponse => {
  const { showSnackbarMessage } = useShowSnackbarMessage();
  const [isError, setIsError] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const resetNewPassword = async ({ token, password }: UseNewUserPassword) => {
    try {
      setIsLoading(true);
      await userService.newPassword({ token, password });
      setIsLoading(false);
      setIsError(false);
      setIsSuccess(true);
      showSnackbarMessage({
        type: `success`,
        messageIntlId: `infoerror.passchange`,
      });
    } catch (error: any) {
      setIsLoading(false);
      setIsError(true);
      setIsSuccess(false);

      console.info(`Reset UserPassword Error: `, error?.response);

      showSnackbarMessage({
        messageIntlId: `infoerror.nopasschange`,
      });
    }
  };

  return {
    success: isSuccess,
    error: isError,
    isLoading,
    run: resetNewPassword,
  };
};
